var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.opened),expression:"opened"}],staticClass:"modal",class:[_vm.width, {'modal--front': _vm.front}]},[_c('div',{staticClass:"modal-content overflow-hidden",class:{'p-0': _vm.noPad}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }